import { render, staticRenderFns } from "./CaseBatchValidator.vue?vue&type=template&id=20846f70&scoped=true&"
import script from "./CaseBatchValidator.vue?vue&type=script&lang=js&"
export * from "./CaseBatchValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20846f70",
  null
  
)

export default component.exports